import {createGlobalStyle, css} from 'styled-components';

export const EGClassicGlobalStyle = css`
    body {
        margin: 0;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
        line-height: 1.42857;
        color: #333;
        background-color: #fff;
    }

    .bootstrap-custom {
        .cms-page-content {
            color: #333;
            h1 {
                font-size: 2.4em;
                padding-bottom: 0.5em;
                font-weight: bold;
            }
            h2 {
                font-size: 1.6em;
            }
            h3 {
                font-size: 1.4em;
            }
            h4 {
                font-size: 1.2em;
            }
        }
        .error-box .cta-button {
            background: #0078f2;
            color: #fff;
        }
        .has-lightbox button {
            color: #c5c5c5;
            font-size: 1.8em;
        }
    }
`;

export const ClassicGlobalStyle = createGlobalStyle`${EGClassicGlobalStyle}`;
